
import { Component, Vue } from 'vue-property-decorator'
import { MediaService } from '@/services/index'
import { Form as ElForm } from 'element-ui'

@Component({
    name: 'MediaOrgEdit',
    components: {
    }
})
export default class extends Vue {

    private relationRules = {
        parentMedia: [
            { required: true, message: '请输入父媒体', trigger: 'blur' }
        ],
        childMedias: [
            { required: true, message: '请输入子媒体', trigger: 'blur' }
        ]
    }
    private relationForm = {
        parentMedia: {},
        childMedias: []
    }
    private isCreateLoading: boolean = false
    private isSearching: boolean = false
    private parentMediaOptions = []
    private childMediaOptions = []

    private async getParentMedias(query: any) {
        if (query !== '') {
            this.isSearching = true
            const result = await MediaService.searchMedia({ value: query })
            if (result.status === 200) {
                this.parentMediaOptions = result.data.map((item: any) => {
                    return { value: item.id, label: item.name }
                })
            }
            this.isSearching = false
        } else {
            this.parentMediaOptions = []
        }
    }

    private async getChildMedias(query: any) {
        if (query !== '') {
            this.isSearching = true
            const result = await MediaService.searchMedia({ value: query })
            if (result.status === 200) {
                this.childMediaOptions = result.data.map((item: any) => {
                    return { value: item.id, label: item.name }
                })
            }
            this.isSearching = false
        } else {
            this.childMediaOptions = []
        }
    }

    private onSelectParentChange() {
        (this.$refs.relationForm as ElForm).validateField('parentMedia')
    }

    private onSelectChildChange() {
        (this.$refs.relationForm as ElForm).validateField('childMedias')
    }

    private onCreate() {
        (this.$refs.relationForm as ElForm).validate(async(valid: boolean) => {
            if (valid) {
                this.isCreateLoading = true
                const { parentMedia, childMedias }: any = this.relationForm
                const params: any = { 
                    parent_media: { id: parentMedia.value, name: parentMedia.label }, 
                    child_medias: childMedias.map((media: any) => { 
                        return { id: media.value, name: media.label } 
                    })
                }
                const result = await MediaService.createRelation(params)
                if (result.status === 200) {
                    (this.$refs.relationForm as ElForm).resetFields()
                    this.$message({ type: 'success', message: '创建成功' })
                } else {
                    this.$message({ type: 'error', message: result.message })
                }
                this.isCreateLoading = false
            } else {
                return false
            }
        })
    }

    private onCancel() {
        this.$router.go(-1)
    }
}
